export default __webpack_public_path__ + "static/media/edit_collection.aa977859.svg";